import { withToast, WithToast } from './Toast';
import { withRouter, RouteComponentProps } from 'react-router';
import { withUser, WithUser } from './User';
import { } from './Transition';

export type DefaultView<Required extends boolean | undefined = false, S = any> = WithUser<Required> & WithToast & RouteComponentProps<{}, {}, S>

export function defaultView<P extends DefaultView>(component: React.ComponentType<P>, required_login: boolean = false) {
    return (withUser(
        withRouter(
            (withToast(component))
        ), required_login
    ) as unknown)
}


// WEBPACK FOOTER //
// ./src/components/HOC/index.ts